import {useQuery} from '@tanstack/react-query';
import {ContentSubmissionSort, SortDir} from '@/types/sorting';
import campaignContentSubmissionFetchers, {
  ContentSubmissionKind,
  ContentSubmissionState,
} from '@/api/fetchers/campaignContentSubmission';

const DEFAULT_STALE_TIME = 30_000;
export const CAMPAIGN_CONTENT_SUBMISSIONS_META_QUERY_KEY =
  'campaignContentSubmissionsMeta';

type UseCampaignContentSubmissionsMetaQueryParams = {
  campaignId: string;
  state?: ContentSubmissionState | ContentSubmissionState[] | string;
  contractId?: string;
  kind?: ContentSubmissionKind;
  profileId?: string;
  enabled?: boolean;
  staleTime?: number;
  sortBy?: ContentSubmissionSort;
  sortDir?: SortDir;
};

function useCampaignContentSubmissionsMetaQuery({
  campaignId,
  state,
  contractId,
  kind,
  profileId,
  enabled = true,
  staleTime = DEFAULT_STALE_TIME,
  sortBy,
  sortDir,
}: UseCampaignContentSubmissionsMetaQueryParams) {
  return useQuery({
    queryKey: [
      CAMPAIGN_CONTENT_SUBMISSIONS_META_QUERY_KEY,
      campaignId,
      state,
      contractId,
      kind,
      profileId,
      sortBy,
      sortDir,
    ],
    queryFn: () =>
      campaignContentSubmissionFetchers.meta({
        campaignId,
        state,
        contractId,
        kind,
        profileId,
        sortBy,
        sortDir,
      }),
    enabled: !!campaignId && enabled,
    staleTime,
  });
}

export default useCampaignContentSubmissionsMetaQuery;
